module.exports = "/_next/static/images/world-map-f00083d6f9641c261abea4055ea88a61.svg";